import {
  login as apphiLoginRes,
  createPubliships as createPublishipsRes,
  register as registerRes,
  validateEmail as validateEmailRes,
} from "../api/users";
import { Base64 as base64 } from "js-base64";
import store from "../store";
import {
  CURRENT_PUBLISHER_ID,
  USER_TOKEN,
  CURRENT_USER_INFO,
  CURRENT_USER_INFO_SIMPLE,
} from "../store/mutation-types";
import app from "../main";

/**
 * apphi用户登录
 * @param email 用户名
 * @param password 密码
 * @returns {Promise<void>}
 */
export async function apphiLogin({ username, password }) {
  const encode = base64.encode(`${username}:${password}`);
  const { data: user } = await apphiLoginRes({
    basic: `${encode}`,
    ignoreToken: true,
    with_stripe: false,
  });
  // 保存当前登录人
  store.commit(USER_TOKEN, user.auth);
  // 保存当前登录人信息到store中
  store.commit(CURRENT_USER_INFO, user);
  // 必须只能选择ins账号(同时防止选中的publisher需要验证)
  let insIndex = user.publiships.findIndex(
    (p) =>
      p.publisher.social_network === 1 &&
      p.publisher.status !== 0 &&
      p.publisher.status !== 2
  );
  // 更改当前选中用户
  if (user.publiships.length > 0) {
    // 如果存在ins账号则选中账号，不能存在则默认选第一个
    if (insIndex === -1) {
      insIndex = 0;
    }
    store.commit(CURRENT_PUBLISHER_ID, user.publiships[insIndex].publisher.id);
  }
  return user;
}

/**
 * 注册用户
 * @param email 用户名
 * @param password 密码
 * @returns {Promise<void>}
 */
export async function register({ email, password }) {
  const { data: user } = await registerRes({ email, password });
  // 保存当前登录人
  store.commit(USER_TOKEN, user.auth);
  // 保存当前登录人信息到store中
  store.commit(CURRENT_USER_INFO, user);
  // 更改当前选中用户
  if (user.publiships[0]) {
    store.commit(CURRENT_PUBLISHER_ID, user.publiships[0].publisher.id);
  }
  return user;
}

/**
 *  与指定 publisher 建立绑定关系。
 * @param username Instagram 用户名
 * @param password Instagram 密码
 * @returns {Promise<void>}
 */
export async function createPubliships({ username, password }) {
  const { data: publiships } = await createPublishipsRes({
    publisher_username: username,
    publisher_password: password,
  });
  await updateUserInfo({});
  return publiships;
}

/**
 * 与指定 publisher 建立绑定关系。
 * @param username
 * @param password
 * @param path
 * @param code
 * @returns {Promise<void>}
 */
export async function createPublishipsByCode({
  username,
  password,
  path,
  code,
}) {
  const { data: publiships } = await createPublishipsRes({
    publisher_username: username,
    publisher_password: password,
    validation_api_path: path,
    validation_code: code,
  });
  await updateUserInfo({});
  return publiships;
}

/**
 * 更新当前登录人用户信息
 * @param withStripe 是否获取信用卡信息
 * @returns {Promise.<*>}
 */
export async function updateUserInfo({ withStripe = false }) {
  const params = { ignoreToken: false, with_stripe: withStripe };
  const { data: user } = await apphiLoginRes(params);
  await initUserInfo(user);
  initSelectPublisher();
  return user;
}

/**
 * 自动选中publisher
 */
export async function initSelectPublisher() {
  const currentPublisherId = store.getters[CURRENT_PUBLISHER_ID];
  const currentUser = store.getters[CURRENT_USER_INFO_SIMPLE];
  // 查看当前选中用户是否存在，如果不存在则尝试默认设置第一个
  if (currentUser.linkedInstagramList.length > 0) {
    if (
      currentUser.linkedInstagramList.findIndex(
        (l) => l.publisherId === currentPublisherId
      ) === -1
    ) {
      console.log(
        "发现原来为未选中状态自动选中publisher",
        currentUser.linkedInstagramList[0].publisherId
      );
      store.commit(
        CURRENT_PUBLISHER_ID,
        currentUser.linkedInstagramList[0].publisherId
      );
    }
  }
}

/**
 * 当登录或者免登时重置本地缓存用户信息
 * @param user
 */
export async function initUserInfo(user) {
  // 保存登录token
  store.commit(USER_TOKEN, user.auth);
  // 将用户信息保存vuex中
  store.commit(CURRENT_USER_INFO, user);
}

/**
 * 直接通过免登陆进入
 * @param auth token
 * @returns {Promise<void>}
 */
export async function autoLogin({ auth }) {
  store.commit(USER_TOKEN, auth);
  await updateUserInfo({});
}

/**
 * 页面登出
 */
export function logout() {
  app.$router.push({ name: "LoginPage" });
}
/**
 * 验证邮箱是否存在
 */
export async function validateEmail({ email }) {
  const { data } = await validateEmailRes({ email });
  return data.existing;
}
